var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ElementRef, OnInit, QueryList } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { config } from '../../../../../config/config';
import { HubFacebookFeedsCommand } from '../../../../commands/hub/event/add.facebook.general.feed.command';
import { CreateEventCommand } from '../../../../commands/hub/event/create.event.command';
import { VisitorSettingsCommand } from '../../../../commands/pagination.query.command';
import { BaseComponent } from '../../../../common/components/base.component';
import { SuccessWrapComponent } from '../../../../common/components/success.wrap/success.wrap.component';
import { localStorageKeys } from '../../../../common/constants/local.storage.keys';
import { clone, isNullOrUndefined } from '../../../../common/extensions';
import { ModalService } from '../../../../common/services/modal.service';
import { HubVisitorFeatureToggle } from '../../../../models/hub/hub.visitor.feature.toggle';
import { AlertifyService } from '../../../../services/alertify.service';
import { EventTimeService } from '../../../../services/event.time.service';
import { HubApiService } from '../../../../services/hub.api.service';
import { ImageService } from '../../../../services/image.service';
import { HubFacebookPageFeedsStore, ToggleStore } from '../../../../stores/hub.calendar.store';
import { HubComponent } from '../../hub.component';
import { VisitorSettingsStore } from '../../../../stores/visitor.calendar.store';
var CreateEventComponent = /** @class */ (function (_super) {
    __extends(CreateEventComponent, _super);
    function CreateEventComponent(formBuilder, activatedRoute, modalService, imageService, parent, togglesStore, visitorSettingsCommand, alertify, hubFacebookFeedsStore, hubApiService) {
        var _this = _super.call(this, { activatedRoute: activatedRoute }) || this;
        _this.formBuilder = formBuilder;
        _this.activatedRoute = activatedRoute;
        _this.modalService = modalService;
        _this.imageService = imageService;
        _this.parent = parent;
        _this.togglesStore = togglesStore;
        _this.visitorSettingsCommand = visitorSettingsCommand;
        _this.alertify = alertify;
        _this.hubFacebookFeedsStore = hubFacebookFeedsStore;
        _this.hubApiService = hubApiService;
        _this.command = new CreateEventCommand();
        _this.time = '00';
        _this.timezoneLabel = '';
        _this.toggles = new HubVisitorFeatureToggle();
        _this.manualSetTimezone = false;
        _this.showTimezoneCitySelector = false;
        _this.isLoadingTimezone = false;
        _this.lastTimezone = null;
        _this.frequencyItems = [];
        _this.frequencyEventTimes = [];
        _this.totalTimes = '';
        _this.dayInWeek = -1;
        _this.hasSetTimezone = false;
        _this.weekNo = -1;
        _this.isImageChanged = false;
        _this.hasCopyrights = false;
        _this.visitorSettings = new VisitorSettingsCommand();
        _this.isAllowOnlineEvents = true;
        _this.resizeImageTemp = null;
        _this.imageUploaderLabel2 = 'Please upload images in JPG, PNG or WEBP format. Landscape images recommended';
        return _this;
    }
    Object.defineProperty(CreateEventComponent.prototype, "timeRangeControls", {
        get: function () {
            return this.createEventForm.get('timeRanges').controls;
        },
        enumerable: true,
        configurable: true
    });
    CreateEventComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.hubName = this.allRouteParams.hubName;
        this.command.defaultImage = config.defaultImageUrl;
        this.createForm();
        this.command.frequency = 'custom';
        this.resetFrequencyDropdown();
        // this.createEventForm.get('facebookEvent')
        //     .valueChanges.subscribe((value: boolean) => {
        //     if (value) {
        //         this.createEventForm.get('hostLink').setValidators(Validators.required);
        //         this.createEventForm.get('eventLink').setValidators(Validators.required);
        //     } else {
        //         this.createEventForm.get('hostLink').clearValidators();
        //         this.createEventForm.get('eventLink').clearValidators()
        //     }
        // });
        this.addTimeRange();
        this.setDefaultTimeValue();
        this.resetTimezoneLabel();
        // this.setImageUploaderLabel2();
        this.visitorSettingsCommand.settingsCommand
            .takeUntil(this.isDestroyed)
            .subscribe(function (settingsCommand) {
            _this.visitorSettings = settingsCommand;
            _this.isAllowOnlineEvents = _this.visitorSettings.isAllowOnlineEvents;
        });
        this.togglesStore.toggleCommand.takeUntil(this.isDestroyed).subscribe(function (toggleCommand) {
            _this.toggles =
                isNullOrUndefined(toggleCommand) || isNullOrUndefined(toggleCommand.placeCalendar)
                    ? new HubVisitorFeatureToggle()
                    : toggleCommand;
            if (_this.toggles.manualEvents === false) {
                for (var i in _this.createEventForm.controls) {
                    var control = _this.createEventForm.controls[i];
                    control.disable();
                }
            }
        });
    };
    Object.defineProperty(CreateEventComponent.prototype, "addressInputLabel", {
        get: function () {
            if (!this.isAllowOnlineEvents) {
                return "Location / Address *";
            }
            return "Location / Address " + (this.command.isOnlineEvent ? '' : '*') + " (or check Virtual Events)";
        },
        enumerable: true,
        configurable: true
    });
    CreateEventComponent.prototype.virtualEventChange = function () {
        if (this.command.isOnlineEvent) {
            this.command.isHybridEvent = false;
        }
    };
    CreateEventComponent.prototype.hybridEventChange = function () {
        if (this.command.isHybridEvent) {
            this.command.isOnlineEvent = false;
        }
    };
    CreateEventComponent.prototype.setFrequencyDropdown = function () {
        if (this.command.eventTimes.length > 0) {
            this.setDefaultTimeValue();
        }
        this.frequencyItems = this.frequencyItems.filter(function (x) { return x.value !== 'last'; });
        var start = this.command.eventTimes[0].startTime;
        this.dayInWeek = EventTimeService.getDayOfWeek(start, this.command.timezone);
        var dayText = config.dayOfWeek[this.dayInWeek].name;
        var weekly = this.frequencyItems.first(function (x) { return x.value === 'weekly'; });
        if (weekly) {
            weekly.text = "Weekly on " + dayText;
        }
        var biWeekly = this.frequencyItems.first(function (x) { return x.value === 'biweekly'; });
        if (biWeekly) {
            biWeekly.text = "Every Other " + dayText + " (starts from " + EventTimeService.getDayAndMonth(start, this.command.timezone) + ")";
        }
        var monthly = this.frequencyItems.first(function (x) { return x.value === 'monthly'; });
        if (monthly) {
            var no = EventTimeService.getWeekDayNo(start, this.command.timezone);
            if (!no.isLast) {
                this.weekNo = no.no;
                monthly.text = "Monthly on the " + no.text + " " + dayText;
                monthly.value = 'monthly';
            }
            else if (no.isLast && no.text === 'last') {
                monthly.text = "Monthly on the last " + dayText;
                monthly.value = 'last';
            }
            else if (no.isLast && no.text !== 'last') {
                this.weekNo = no.no;
                monthly.text = "Monthly on the " + no.text + " " + dayText;
                monthly.value = 'monthly';
                this.frequencyItems.push({
                    value: 'last',
                    text: "Monthly on the last " + dayText,
                });
            }
        }
    };
    CreateEventComponent.prototype.frequencySourceChange = function (target) {
        var _this = this;
        this.command.frequency = target.value;
        var start = this.command.eventTimes[0].startTime;
        var end = this.command.eventTimes[0].endTime;
        // end = EventTimeService.addHours(new Date(end), -1);
        var eventTimes = [], days = [];
        var diff = 0;
        var scrossDaylight = '';
        switch (target.value) {
            case 'daily':
                diff = EventTimeService.diff(start, end);
                this.totalTimes = diff + 1 + " Dates " + EventTimeService.getDayAndMonth(start, this.command.timezone) + " - " + EventTimeService.getDayAndMonth(end, this.command.timezone);
                for (var i = 0; i <= diff; i++) {
                    var startTime = EventTimeService.addHours(new Date(start), 24 * i);
                    var time = this.adjustForDaylightSaving(start, end, startTime);
                    this.setEventTimes(time.startTime, time.endTime, eventTimes);
                    scrossDaylight = time.scrossDaylight;
                }
                if (scrossDaylight === 'ST') {
                    for (var _i = 0, eventTimes_1 = eventTimes; _i < eventTimes_1.length; _i++) {
                        var time = eventTimes_1[_i];
                        time.endTime = EventTimeService.addHours(time.endTime, -1);
                    }
                }
                if (scrossDaylight === 'DT') {
                    for (var _a = 0, eventTimes_2 = eventTimes; _a < eventTimes_2.length; _a++) {
                        var time = eventTimes_2[_a];
                        time.endTime = EventTimeService.addHours(time.endTime, 1);
                    }
                }
                break;
            case 'weekly':
                diff = EventTimeService.diff(start, end, 'weeks');
                this.totalTimes = diff + 1 + " Dates " + EventTimeService.getDayAndMonthAndYear(start, this.command.timezone) + " - " + EventTimeService.getDayAndMonthAndYear(end, this.command.timezone);
                for (var i = 0; i <= diff; i++) {
                    var startTime = EventTimeService.addHours(new Date(start), 24 * 7 * i);
                    var time = this.adjustForDaylightSaving(start, end, startTime);
                    this.setEventTimes(time.startTime, time.endTime, eventTimes);
                    scrossDaylight = time.scrossDaylight;
                }
                if (scrossDaylight === 'ST') {
                    for (var _b = 0, eventTimes_3 = eventTimes; _b < eventTimes_3.length; _b++) {
                        var time = eventTimes_3[_b];
                        time.endTime = EventTimeService.addHours(time.endTime, -1);
                    }
                }
                if (scrossDaylight === 'DT') {
                    for (var _c = 0, eventTimes_4 = eventTimes; _c < eventTimes_4.length; _c++) {
                        var time = eventTimes_4[_c];
                        time.endTime = EventTimeService.addHours(time.endTime, 1);
                    }
                }
                break;
            case 'biweekly':
                diff = EventTimeService.diff(start, end, 'biweekly');
                this.totalTimes = diff + 1 + " Dates " + EventTimeService.getDayAndMonthAndYear(start, this.command.timezone) + " - " + EventTimeService.getDayAndMonthAndYear(end, this.command.timezone);
                for (var i = 0; i <= diff; i++) {
                    var startTime = EventTimeService.addHours(new Date(start), 24 * 14 * i);
                    var time = this.adjustForDaylightSaving(start, end, startTime);
                    this.setEventTimes(time.startTime, time.endTime, eventTimes);
                    scrossDaylight = time.scrossDaylight;
                }
                if (scrossDaylight === 'ST') {
                    for (var _d = 0, eventTimes_5 = eventTimes; _d < eventTimes_5.length; _d++) {
                        var time = eventTimes_5[_d];
                        time.endTime = EventTimeService.addHours(time.endTime, -1);
                    }
                }
                if (scrossDaylight === 'DT') {
                    for (var _e = 0, eventTimes_6 = eventTimes; _e < eventTimes_6.length; _e++) {
                        var time = eventTimes_6[_e];
                        time.endTime = EventTimeService.addHours(time.endTime, 1);
                    }
                }
                break;
            case 'monthly':
                days = EventTimeService.getSameDayInWeek(start, end, this.dayInWeek, this.weekNo, this.command.timezone);
                this.totalTimes = days.length + " Dates " + EventTimeService.getDayAndMonthAndYear(start, this.command.timezone) + " - " + EventTimeService.getDayAndMonthAndYear(end, this.command.timezone);
                days.forEach(function (x) {
                    var time = _this.adjustForDaylightSaving(start, end, x);
                    _this.setEventTimes(time.startTime, time.endTime, eventTimes);
                    scrossDaylight = time.scrossDaylight;
                });
                if (scrossDaylight === 'ST') {
                    for (var _f = 0, eventTimes_7 = eventTimes; _f < eventTimes_7.length; _f++) {
                        var time = eventTimes_7[_f];
                        time.endTime = EventTimeService.addHours(time.endTime, -1);
                    }
                }
                if (scrossDaylight === 'DT') {
                    for (var _g = 0, eventTimes_8 = eventTimes; _g < eventTimes_8.length; _g++) {
                        var time = eventTimes_8[_g];
                        time.endTime = EventTimeService.addHours(time.endTime, 1);
                    }
                }
                break;
            case 'last':
                days = EventTimeService.getLastWeekDays(start, end, this.dayInWeek, this.command.timezone);
                this.totalTimes = days.length + " Dates " + EventTimeService.getDayAndMonthAndYear(start, this.command.timezone) + " - " + EventTimeService.getDayAndMonthAndYear(end, this.command.timezone);
                days.forEach(function (x) {
                    var time = _this.adjustForDaylightSaving(start, end, x);
                    _this.setEventTimes(time.startTime, time.endTime, eventTimes);
                    scrossDaylight = time.scrossDaylight;
                });
                if (scrossDaylight === 'ST') {
                    for (var _h = 0, eventTimes_9 = eventTimes; _h < eventTimes_9.length; _h++) {
                        var time = eventTimes_9[_h];
                        time.endTime = EventTimeService.addHours(time.endTime, -1);
                    }
                }
                if (scrossDaylight === 'DT') {
                    for (var _j = 0, eventTimes_10 = eventTimes; _j < eventTimes_10.length; _j++) {
                        var time = eventTimes_10[_j];
                        time.endTime = EventTimeService.addHours(time.endTime, 1);
                    }
                }
                break;
            default:
                break;
        }
        this.frequencyEventTimes = eventTimes;
    };
    CreateEventComponent.prototype.createForm = function () {
        this.createEventForm = this.formBuilder.group({
            name: [null, [Validators.required]],
            description: [null, []],
            // timeRanges: this.formBuilder.array([]),
            address: [null, []],
            host: [null, [Validators.required]],
            category: [null, []],
            ticketUri: [null, []],
            facebookEvent: [null, []],
            hostLink: [null, []],
            eventLink: [null, []],
            imageLink: [null, []],
            timezone: [null, []],
            venue: [null, []],
            organizerEmail: [null, []],
        });
    };
    Object.defineProperty(CreateEventComponent.prototype, "isFormInvalid", {
        get: function () {
            return (this.createEventForm.invalid ||
                (!this.command.isOnlineEvent && !this.command.address) ||
                (this.isImageChanged && !this.hasCopyrights));
        },
        enumerable: true,
        configurable: true
    });
    CreateEventComponent.prototype.createEvent = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var hubName, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // if (!this.hasSetTimezone) {
                        if (!this.command.timezone) {
                            this.alertify.warning('Please set the timezone');
                            event.complete();
                            return [2 /*return*/];
                        }
                        hubName = this.allRouteParams.hubName;
                        this.command.isHubCreated = true;
                        if (!this.resizeImageTemp) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.hubApiService.uploadBase64ImageToAWS(this.resizeImageTemp)];
                    case 1:
                        res = _a.sent();
                        if (res.success) {
                            this.command.image = null;
                            this.command.imageLink = res.url;
                        }
                        _a.label = 2;
                    case 2:
                        if (this.command.address &&
                            this.command.address.address_components &&
                            this.command.address.address_components.length > 0) {
                            this.command.address.addressComponents = clone(this.command.address.address_components);
                            delete this.command.address.address_components;
                        }
                        this.hubApiService
                            .createEvent(hubName, this.command, this.frequencyEventTimes)
                            .finally(event.complete)
                            .subscribe(function () {
                            _this.alertify.successfully('Create event');
                            _this.command = new CreateEventCommand();
                            _this.command.frequency = 'custom';
                            _this.resetFrequencyDropdown();
                            _this.createForm();
                            _this.addTimeRange();
                            _this.setDefaultTimeValue();
                            _this.lastTimezone ? (_this.command.timezone = _this.lastTimezone) : _this.resetTimezoneLabel();
                            _this.descriptionArea.nativeElement.style.height = '40px';
                            _this.resizeImageTemp = null;
                            _this.hubApiService.getPageFeeds(_this.hubName).subscribe(function (data) {
                                var pageCommand = new HubFacebookFeedsCommand(data);
                                _this.hubFacebookFeedsStore.pagesCommand.next(pageCommand);
                            });
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    CreateEventComponent.prototype.onImageChange = function (file) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!file) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.imageService.compressImageFileToBase64(file, config.compressImgWidth)];
                    case 1:
                        _a.resizeImageTemp = _b.sent();
                        // console.log('resizeImageTemp 1', this.resizeImageTemp.length);
                        // // do not allow over 1MB
                        // if (this.resizeImageTemp.length > 1000000) {
                        //   this.resizeImageTemp = await this.imageService.compressImageFileToBase64(file, 600);
                        //   console.log('resizeImageTemp 2', this.resizeImageTemp.length);
                        // }
                        this.isImageChanged = true;
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    CreateEventComponent.prototype.imageResized = function (imgBase64) {
        this.resizeImageTemp = imgBase64;
    };
    CreateEventComponent.prototype.setEventTime = function (time, timeRange) {
        if (time.startTime) {
            timeRange.startTime = time.startTime;
        }
        if (time.endTime) {
            timeRange.endTime = time.endTime;
        }
        this.frequencySourceChange({ value: this.command.frequency });
    };
    CreateEventComponent.prototype.showTimezoneCity = function () {
        if (this.toggles.manualEvents) {
            this.showTimezoneCitySelector = true;
        }
    };
    CreateEventComponent.prototype.addTimeRange = function () {
        this.command.eventTimes.push({});
        // let timeRangeGroups = (<FormArray>this.createEventForm.get('timeRanges')).controls;
        // let getTimeRangeFunc = () => {
        //     let group = timeRangeGroups[this.command.eventTimes.length - 1];
        //     return group ? {start: group.get('startTime').value, end: group.get('endTime').value} : null;
        // };
        // let getOtherTimeRangesFunc = () => {
        //     let otherGroups = timeRangeGroups.slice(0, this.command.eventTimes.length - 1);
        //     return otherGroups.map(group => {
        //         return {start: group.get('startTime').value, end: group.get('endTime').value};
        //     });
        // };
        // let timeRangeValidator = timeRangeOverlapValidate(getTimeRangeFunc, getOtherTimeRangesFunc);
        // (<FormArray>this.createEventForm.get('timeRanges'))
        //     .push(this.formBuilder.group({
        //         startTime: [null, [Validators.required, timeRangeValidator]],
        //         endTime: [null, [Validators.required, timeRangeValidator]]
        //     }));
    };
    CreateEventComponent.prototype.removeTimeRange = function (i) {
        this.command.eventTimes.splice(i, 1);
        //(<FormArray>this.createEventForm.get('timeRanges')).removeAt(i);
    };
    CreateEventComponent.prototype.canDeactivate = function () {
        if (this.createEventForm.pristine) {
            return Observable.of(true);
        }
        var allowNavigate = new Subject();
        this.modalService.showUnSaveWarning({ allowNavigate: allowNavigate });
        return allowNavigate;
    };
    CreateEventComponent.prototype.descriptionChange = function () {
        this.descriptionArea.nativeElement.style.height =
            Math.min(this.descriptionArea.nativeElement.scrollHeight, 500) + 'px';
    };
    CreateEventComponent.prototype.resetTimezoneLabel = function () {
        // this.timezoneLabel = 'Timezone * (enter a city)';
        var timezoneFormatterDefault = localStorage.getItem(localStorageKeys.timezoneFormatterDefault);
        if (timezoneFormatterDefault && timezoneFormatterDefault !== 'undefined') {
            this.command.timezone = EventTimeService.getTimezoneCodeByFormatter(timezoneFormatterDefault);
            this.timezoneLabel = "Timezone (" + this.command.timezone + ")";
        }
        else {
            this.command.timezone = null; //EventTimeService.getTimezoneCode();
            this.manualSetTimezone = true;
            this.timezoneLabel = "Enter a city to set timezone *";
        }
    };
    CreateEventComponent.prototype.citySelected = function () {
        var _this = this;
        if (this.timezoneAddress) {
            this.isLoadingTimezone = true;
            this.hubApiService
                .getTimezoneByLatlng(this.timezoneAddress.lat, this.timezoneAddress.lng)
                .finally(function () {
                _this.isLoadingTimezone = false;
            })
                .subscribe(function (data) {
                console.log(data);
                _this.command.timezone = data.abbreviation;
                _this.lastTimezone = _this.command.timezone;
                _this.hasSetTimezone = true;
                _this.timezoneLabel = "Timezone (" + _this.command.timezone + ")";
                _this.dateTimeInput.toArray().forEach(function (x) {
                    x.timeFormatter = EventTimeService.getTimezoneFormatterByTimezone(_this.command.timezone);
                    x.timezone = _this.command.timezone;
                    x.setTime('start');
                    x.setTime('end');
                });
            });
        }
    };
    CreateEventComponent.prototype.adjustForDaylightSaving = function (start, end, nextDayStart) {
        var formatter = EventTimeService.getTimezoneFormatterByTimezone(this.command.timezone);
        var startTimezone = EventTimeService.getTimezonecodeWithTimeSaving(start, formatter);
        var nextDayTimezone = EventTimeService.getTimezonecodeWithTimeSaving(nextDayStart, formatter);
        var thisEnd = end;
        var scrossDaylight = '';
        console.log('startTimezone, nextDayTimezone', startTimezone, nextDayTimezone);
        if (startTimezone !== nextDayTimezone) {
            if (nextDayTimezone.indexOf('ST') >= 0) {
                nextDayStart = EventTimeService.addHours(nextDayStart, 1);
                thisEnd = EventTimeService.addHours(thisEnd, 1);
                scrossDaylight = 'ST';
            }
            else {
                nextDayStart = EventTimeService.addHours(nextDayStart, -1);
                thisEnd = EventTimeService.addHours(thisEnd, -1);
                scrossDaylight = 'DT';
            }
        }
        return {
            startTime: nextDayStart,
            endTime: thisEnd,
            scrossDaylight: scrossDaylight,
        };
    };
    CreateEventComponent.prototype.resetFrequencyDropdown = function () {
        this.frequencyItems = [
            {
                text: 'Custom',
                value: 'custom',
                selected: true,
            },
            {
                text: 'Daily',
                value: 'daily',
            },
            {
                text: 'Weekly',
                value: 'weekly',
            },
            {
                text: 'Biweekly',
                value: 'biweekly',
            },
            {
                text: 'Monthly',
                value: 'monthly',
            },
        ];
    };
    CreateEventComponent.prototype.setEventTimes = function (start, end, eventTimes) {
        var startTime = start;
        var endTime = new Date(new Date(startTime).setUTCHours(new Date(end).getUTCHours()));
        endTime = new Date(endTime.setUTCMinutes(new Date(end).getUTCMinutes()));
        if (endTime < new Date(startTime)) {
            endTime = new Date(EventTimeService.addHours(endTime, 24));
        }
        eventTimes.push({
            startTime: startTime,
            endTime: endTime.toISOString(),
        });
    };
    CreateEventComponent.prototype.setDefaultTimeValue = function () {
        var endPlusHours = 0;
        switch (this.command.frequency) {
            case 'custom':
                endPlusHours = 24 + 3;
                break;
            case 'daily':
                endPlusHours = 24 * 7 + 3;
                break;
            case 'weekly':
                endPlusHours = 24 * 365 + 3;
                break;
        }
        if (!this.command.eventTimes[0].startTime && !this.command.eventTimes[0].endTime) {
            this.command.eventTimes = [
                {
                    startTime: EventTimeService.getDefaultStartTime(this.command.timezone),
                    endTime: EventTimeService.addHours(EventTimeService.getDefaultStartTime(this.command.timezone), endPlusHours),
                },
            ];
        }
        else if (this.command.eventTimes[0].startTime && !this.command.eventTimes[0].endTime) {
            this.command.eventTimes = [
                {
                    startTime: this.command.eventTimes[0].startTime,
                    endTime: EventTimeService.addHours(new Date(this.command.eventTimes[0].startTime), 24 * 7),
                },
            ];
        }
        else if (!this.command.eventTimes[0].startTime && this.command.eventTimes[0].endTime) {
            this.command.eventTimes = [
                {
                    startTime: EventTimeService.addHours(new Date(this.command.eventTimes[0].startTime), 24 * 7 * -1),
                    endTime: this.command.eventTimes[0].endTime,
                },
            ];
        }
    };
    CreateEventComponent.prototype.setImageUploaderLabel2 = function () {
        var settingStorage = localStorage.getItem(localStorageKeys.allBackendSettings);
        if (settingStorage) {
            var settings = JSON.parse(settingStorage);
            this.visitorSettings = settings.customSettings;
            console.log(this.visitorSettings);
            if (this.visitorSettings.calendarStyle.event === 'square') {
                this.imageUploaderLabel2 = this.imageUploaderLabel2.replace('360px', '640px');
            }
            if (!isNullOrUndefined(this.visitorSettings.isAllowOnlineEvents)) {
                this.isAllowOnlineEvents = this.visitorSettings.isAllowOnlineEvents;
            }
        }
    };
    return CreateEventComponent;
}(BaseComponent));
export { CreateEventComponent };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/manually.add/create.event/create.event.component.ts.pre-build-optimizer.js